import * as React from 'react';
import {useNavigate} from "react-router-dom";
import {Add, GetApp, Room, Upload} from "@mui/icons-material";
import {Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField} from "@mui/material";
import * as XLSX from "xlsx";
import CancelIcon from "@mui/icons-material/Cancel";
import SimpleMap from "../../components/SimpleMap";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {useSnackbar} from "notistack";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {
  setAddressSender,
  setBreakableSender,
  setCityIDSender,
  setCityNameSender,
  setCompanySender,
  setEmailSender,
  setFactorSender,
  setFirstNameSender,
  setLastNameSender,
  setLatSender,
  setLiquidSender,
  setLngSender,
  setMobileNumberSender,
  setNeedSender,
  setNotificationSender,
  setPostalCodeSender,
  setServicesNameSender,
  setServicesSender,
  setStateIDSender,
  setStateNameSender,
  setTrademarkSender,
} from "../../redux/multiOrder/sender/actions";

import {setLoading} from "../../redux/loading/actions";
import {setAgentServices, setExcelListBox} from "../../redux/multiOrder/infoBox/actions";
import {ReactComponent as Plus} from "../../assets/img/icons/plus.svg";
import {addCommas, handleBorderColor, removeNonNumeric} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";


export default function Sender(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();
  const {fetchData} = HandleFetchData()


  const [beforeAddressDialog, setBeforeAddressDialog] = React.useState(false);
  const [afterAddressDialog, setAfterAddressDialog] = React.useState(false);
  const [coordinateDialog, setCoordinateDialog] = React.useState(false);
  const [listServices, setListServices] = React.useState([]);
  const [excel, setExcel] = React.useState();
  const [itemExcel, setItemExcel] = React.useState([]);
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [listAddress, setListAddress] = React.useState([])
  const [textStateAndCity, setTextStateAndCity] = React.useState('')

  const [tooltip1, setTooltip1] = React.useState(false);
  const [tooltip2, setTooltip2] = React.useState(false);
  const [tooltip3, setTooltip3] = React.useState(false);
  const [tooltip4, setTooltip4] = React.useState(false);
  const [tooltip5, setTooltip5] = React.useState(false);
  const [tooltip6, setTooltip6] = React.useState(false);
  const [openMenuExcel, setOpenMenuExcel] = React.useState(false);


  const [validationShow, setValidationShow] = React.useState({});

  const [newAddress, setNewAddress] = React.useState('')
  const [newStateAndCity, setNewStateAndCity] = React.useState(null)

  const [userInfo, setUserInfo] = React.useState(null)

  React.useEffect(() => {
    getServices()
    getStateAndCity()
    setUserInfo(JSON.parse(localStorage.getItem('info-user')))
  }, [])



  const validationsNewAddress = () => {
    if (!newStateAndCity) {
      setValidationShow({
        stateAndCity: 'انتخاب شهر و استان الزامی میباشد'
      })
    } else if (!newAddress) {
      setValidationShow({
        newAddress: 'وارد کردن آدرس الزامی میباشد'
      })
    } else if (!selector?.multi_sender?.lat || !selector?.multi_sender?.lng) {
      setValidationShow({
        coordinate: 'انتخاب موقعیت مکانی الزامی میباشد'
      })
    } else {
      handleAddNewAddress()
    }
  }
  const handleAddNewAddress = () => {
    dispatch(setAddressSender(newAddress))
    setInfoStateAndCity(newStateAndCity);
    setAfterAddressDialog(false)
  }
  const handleRemoveNewAddress = () => {
    setAfterAddressDialog(false)
  }

  // متد دریافت لیست آدرس های قبلی
  const getPreviousAddress = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', `/FetchAddresses?toSearch=${e}`, '', 'application/json','', 'postex')
    dispatch(setLoading(false))
    setListAddress(fetch?.Data || [])
  }

  // متد دریافت لیست استان ها
  const getStateAndCity = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    dispatch(setLoading(false))
  }

  // متد دریافت لیست سرویس ها
  const getServices = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', `/getServiceList`, '', "application/json",'', '','')
    setListServices(fetch)
    dispatch(setLoading(false))
  }

  const onExcelChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setExcel(URL.createObjectURL(event.target.files[0]))
      readExcel(event.target.files[0])
    }
  }

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, {type: "buffer"});
        const wsName = wb.SheetNames[0];
        const ws = wb.Sheets[wsName];
        const data = XLSX.utils.sheet_to_json(ws);
        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      dispatch(setExcelListBox(d))
      setItemExcel(d);
      // renderItemExcelToList(d)
    });
  };


  const renderItemExcelToList = (e) => {
    Object.keys(e[0]).map((item, index) => console.log('Object', item, index))
    e.map((item1, index1) => (
       <tr key={index1}>
         <td>{index1}</td>
         {Object.values(item1).map((item2, index2) => console.log('item2', item2, index2))}
       </tr>
    ))
  }

  const handleNotificationMessage = (event) => {
    dispatch(setNotificationSender(event.target.checked))
    // props.handlerNotificationMessage(event.target.checked);
    handleTimeOutTooltip(setTooltip3)
  }

  const setInfoStateAndCity = (value) => {
    dispatch(setCityNameSender(value?.name?.split('-')[1] || ''))
    // dispatch(setCityNameSender(value?.StateProvinceName || ''))
    dispatch(setCityIDSender(value?.id?.split('-')[1] || ''))
    // dispatch(setCityIDSender(value?.StateProvinceId || ''))
    dispatch(setStateNameSender(value?.name?.split('-')[0] || ''))
    // dispatch(setStateNameSender(value?.Country || ''))
    dispatch(setStateIDSender(value?.id?.split('-')[0] || ''))
    // dispatch(setStateIDSender(value?.CountryId || ''))
    dispatch(setLatSender(value?.lat || ''))
    dispatch(setLngSender(value?.lon || ''))
  }

  const setInfoSender = (value) => {
    dispatch(setFirstNameSender(value?.FirstName || ''))
    dispatch(setLastNameSender(value?.LastName || ''))
    // dispatch(setNationalCodeSender(value?.national_code || ''))
    dispatch(setPostalCodeSender(value?.ZipPostalCode || ''))
    dispatch(setEmailSender(value?.email || ''))
    dispatch(setCompanySender(value?.Company || ''))
    dispatch(setMobileNumberSender(value?.PhoneNumber || ''))
    // dispatch(setPhoneNumberSender(value?.phone_no || ''))
    dispatch(setAddressSender(value?.Address1 || ''))
    dispatch(setCityNameSender(value?.StateProvinceName || ''))
    dispatch(setCityIDSender(value?.StateProvinceId || ''))
    dispatch(setStateNameSender(value?.Country || ''))
    dispatch(setStateIDSender(value?.CountryId || ''))
    dispatch(setLatSender(value?.Lat || ''))
    dispatch(setLngSender(value?.Lon || ''))
  }


  const handleTimeOutTooltip = (state) => {
    state(true)
    setTimeout(() => {
      state(false)
    }, 4000)
  }


  return (
     <>
       <div className="senderMultiOrderPage">


         <div className="row">
           <div className={"col-12 " + (userInfo?.IsAgent ? "col-md-6" : "col-md-12") } ref={props.servicesRefSender}>
             <h4 className="titleSection">{t("multiOrder.s1.t4")}</h4>
             <label className="required">{t("multiOrder.s1.t5")}</label>
             <select aria-label="Default select example" value={selector?.multi_sender?.services_name}
                     style={handleBorderColor(props.validation?.service_validation_Sender)}
                     onChange={(event) => {
                       dispatch(setServicesSender(event.target.value))
                       dispatch(setServicesNameSender(
                          listServices?.find(x => x?.ServiceId.toString() === event?.target?.value.toString())?.ServiceName
                       ))
                     }}>
               <option value="" selected disabled>{selector?.multi_sender?.services_name}</option>
               {
                 listServices?.map((item, index) => <option key={item?.ServiceId} value={item?.ServiceId}>{item.ServiceName}</option>)
               }
             </select>

             {
               props.validation?.service_validation_Sender &&
               <p className="error">{props.validation?.service_validation_Sender}</p>
             }
           </div>

           {
             userInfo && userInfo?.IsAgent &&
             <div className="col-12 col-md-6 agentServices">
               <h4 className="titleSection">{t("singleOrder.packageInfo.t39")}</h4>

               <label className="mt-4">{t("singleOrder.packageInfo.t40")}</label>
               <input type="text" autoComplete="on"
                      inputMode='numeric'
                      value={selector?.multi_info_box?.agent_services}
                      onChange={e => dispatch(setAgentServices(addCommas(removeNonNumeric(e.target.value))))}/>
             </div>
           }

           <Divider className="d-none d-lg-block"/>


           <div className="col-12 col-lg-6" ref={props.firstNameRefSender}>
             <label className="required">{t("singleOrder.sender.t6")}</label>
             <input type="text" name="firstName"
                    style={handleBorderColor(props.validation?.firstName_validation_Sender)}
                    value={selector?.multi_sender?.first_name}
                    onChange={e => dispatch(setFirstNameSender(e.target.value))}/>

             {
               props.validation?.firstName_validation_Sender &&
               <p className="error">{props.validation?.firstName_validation_Sender}</p>
             }

           </div>
           <div className="col-12 col-lg-6" ref={props.lastNameRefSender}>
             <label className="required">{t("singleOrder.sender.t7")}</label>
             <input type="text" name="lastName"
                    style={handleBorderColor(props.validation?.lastName_validation_Sender)}
                    value={selector?.multi_sender?.last_name}
                    onChange={e => dispatch(setLastNameSender(e.target.value))}/>

             {
               props.validation?.lastName_validation_Sender &&
               <p className="error">{props.validation?.lastName_validation_Sender}</p>
             }
           </div>
           <div className="col-12 col-md-6" ref={props.postalCodeRefSender}>
             <label className="">{t("singleOrder.sender.t27")}</label>
             <input type="text" name="postalCode" className="numeric" value={selector?.multi_sender?.postal_code}
                    style={handleBorderColor(props.validation?.postalCode_validation_Sender)}
                    onChange={e => e?.target?.value?.length <= 10 &&
                       dispatch(setPostalCodeSender(removeNonNumeric(e.target.value)))
                    }
             />
             {/*{*/}
             {/*  props.validation?.postalCode_validation_Sender &&*/}
             {/*  <p className="error">{props.validation?.postalCode_validation_Sender}</p>*/}
             {/*}*/}
           </div>
           <div className="col-12 col-lg-6" ref={props.mobileRefSender}>
             <label className="required">{t("singleOrder.sender.t8")}</label>
             <input type="text" name="phone" className="numeric" value={selector?.multi_sender?.mobile_number}
                    style={handleBorderColor(props.validation?.mobileNumber_validation_Sender)}
                    onChange={e => e.target.value.length <= 11 && dispatch(setMobileNumberSender(removeNonNumeric(e.target.value)))}
             />
             {
               props.validation?.mobileNumber_validation_Sender &&
               <p className="error">{props.validation?.mobileNumber_validation_Sender}</p>
             }
           </div>
           <div className="col-12 col-lg-6">
             <label>{t("singleOrder.sender.t9")}</label>
             <input type="email" name="email"
                    value={selector?.multi_sender?.email}
                    onChange={e => dispatch(setEmailSender(e.target.value))}/>
           </div>
           <div className="col-12 col-lg-6">
             <label>{t("singleOrder.sender.t10")}</label>
             <input type="text" name="company"
                    value={selector?.multi_sender?.company}
                    onChange={e => dispatch(setCompanySender(e.target.value))}/>
           </div>


           <div className="col-12 mt-4" ref={props.addressRefSender}>
             <div className="d-none d-lg-block">
               <h4 className="titleSection">{t("singleOrder.sender.t14")}</h4>
               <div className="d-flex align-items-center">
                 <Autocomplete
                    className="w-100"
                    inputValue={selector?.multi_sender?.address}
                    noOptionsText={t("autoComplete.t1")}
                    value={selector?.multi_sender?.address}
                    id="previous-address-sender-1"
                    disablePortal
                    onChange={(e, value, reason) => {
                      if (reason === 'clear') {
                        setInfoSender(null)
                      } else {
                        setInfoSender(value)
                      }
                    }}
                    options={listAddress || []}
                    getOptionLabel={(option) => option?.Address1 || ''}
                    renderOption={(props, option) => <li {...props}
                                                         key={option?.Id}>{option?.Address1}</li>}
                    renderInput={(params) =>
                       <TextField {...params}
                                  hiddenLabel
                                  size="small"
                                  placeholder={t("singleOrder.sender.t16")}
                                  style={handleBorderColor(props.validation?.address_validation_Sender)}
                                  onChange={event => {
                                    dispatch(setAddressSender(event.target.value))
                                    event.target.value?.length >= 3 && getPreviousAddress(event.target.value)
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                       <React.Fragment>
                                         {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                         {params.InputProps.endAdornment}
                                       </React.Fragment>
                                    ),
                                  }}
                       />}
                 />

                 <div className="btnGroup_yellow btn-add-address w-auto">
                   <button className="btnFill" onClick={() => {
                     setAfterAddressDialog(true)
                   }} id="openAfterAddressDialog">
                     <Add/>
                   </button>
                 </div>
               </div>

               {
                 selector?.multi_sender?.address && (!selector?.multi_sender?.lat || !selector?.multi_sender?.lng) &&
                 <div className="btnGroup_yellow btn-add-coordinate">
                   <button className="btnFill" onClick={() => {
                     setCoordinateDialog(true)
                   }} id="openCoordinateDialog">
                     {t("singleOrder.receiver.t29")}
                   </button>
                 </div>
               }


               {
                 props.validation?.address_validation_Sender &&
                 <p className="error">{props.validation?.address_validation_Sender}</p>
               }
             </div>

             <div className="d-none d-lg-block">
               <div className="_btnGroup_yellow d-flex d-lg-none">
                 <button className="btnFill" onClick={() => setAfterAddressDialog(false)} id="closeAfterAddressDialog">
                   {t("singleOrder.sender.t22")}
                 </button>
               </div>
             </div>
           </div>
         </div>

         <div className="s1 d-block d-lg-none" ref={props.address1RefSender}>
           <div className="address">
             <h4 className="titleSection">{t("multiOrder.s1.t1")}</h4>
             <div className="btnGroup_yellow">
               <button className="btnFill" onClick={() => setBeforeAddressDialog(true)} id="openBeforeAddressDialog">
                 <span>{t("multiOrder.s1.t2")}</span>
                 <Room fontSize="large"/>
               </button>
               <button className="btnEmpty" onClick={() => setAfterAddressDialog(true)} id="openAfterAddressDialog">
                 <span>{t("multiOrder.s1.t3")}</span>
                 <Add fontSize="large"/>
               </button>
             </div>
           </div>
         </div>

         <div className="row mt-3">
           <div className="col-12 col-lg-6">
             <section className="s3">
               <h4 className="titleSection">{t("multiOrder.s1.t23")}</h4>
               <div className="_btnGroup_blue">
                 <button className="btnFill" onClick={() => setOpenMenuExcel(!openMenuExcel)} id="openMenuExcel">
                   <span>{t("multiOrder.s1.t13")}</span>
                   <GetApp fontSize="large"/>
                   <div className={`dropdown-list-excel ${openMenuExcel && 'active'}`}>

                     <a href="https://app.postex.ir/Pk.xlsx" download={t("multiOrder.s1.t26")} id="PkExcel">
                       {t("multiOrder.s1.t26")}
                     </a>
                     <a href="https://app.postex.ir/COD.xlsx" download={t("multiOrder.s1.t27")} id="CODExcel">
                       {t("multiOrder.s1.t27")}
                     </a>
                   </div>
                 </button>

                 <button
                    className="btnEmpty">
                   <label htmlFor="upload">
                     <span>{t("multiOrder.s1.t14")}</span>
                     <Upload fontSize="large"/>
                   </label>
                   <input type="file" name="excel" accept="xlsx, xls" multiple={false} id="upload" onChange={onExcelChange}/>
                 </button>

               </div>
             </section>
           </div>
           <div className="col-12 col-lg-6">
             <section className="s2">
               <div className="row">
                 <div className="col-12 col-md-6 d-flex">
                   <div className="checkBox_yellow">
                     <FormControlLabel control={<Checkbox
                        id="need"
                        checked={selector?.multi_sender?.need}
                        onChange={e => {
                          dispatch(setNeedSender(e.target.checked))
                          handleTimeOutTooltip(setTooltip1)
                        }}/>} label={t("singleOrder.packageInfo.t6")}/>
                   </div>
                   <div className="helper">
                     <Tooltip title={
                       selector?.multi_sender?.need ?
                          t("singleOrder.packageInfo.t24")
                          :
                          t("singleOrder.packageInfo.t25")

                     } PopperProps={{
                       disablePortal: true,
                     }}
                              onClose={() => setTooltip1(false)}
                              open={tooltip1}
                              placement="top-start"
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener>
                       <InfoIcon color="primary" onClick={() => handleTimeOutTooltip(setTooltip1)}/>
                     </Tooltip>
                   </div>
                 </div>
                 <div className="col-12 col-md-6 d-flex">
                   <div className="checkBox_yellow">
                     <FormControlLabel control={<Checkbox
                        id="factor"
                        disabled={selector?.multi_sender?.need}
                        checked={
                          selector?.multi_sender?.need ? true : selector?.multi_sender?.factor
                        }
                        onChange={e => {
                          dispatch(setFactorSender(e.target.checked))
                          handleTimeOutTooltip(setTooltip2)
                        }}/>}
                                       label={t("singleOrder.packageInfo.t7")}/>
                   </div>
                   <div className="helper">
                     <Tooltip title={t("singleOrder.packageInfo.t28")}
                              PopperProps={{disablePortal: true}}
                              onClose={() => setTooltip2(false)}
                              open={tooltip2}
                              placement="top-start"
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener>
                       <InfoIcon color="primary" onClick={() => handleTimeOutTooltip(setTooltip2)}/>
                     </Tooltip>
                   </div>

                 </div>
                 <div className="col-12 col-md-6 d-flex">
                   <div className="checkBox_yellow">
                     <FormControlLabel
                        control={<Checkbox id="notification" checked={selector?.multi_sender?.notification}
                                           onChange={handleNotificationMessage}/>}
                        label={t("singleOrder.packageInfo.t8")}/>
                   </div>
                   <div className="helper">
                     <Tooltip title={t("singleOrder.packageInfo.t29")}
                              PopperProps={{disablePortal: true}}
                              onClose={() => setTooltip3(false)}
                              open={tooltip3}
                              placement="top-start"
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener>
                       <InfoIcon color="primary" onClick={() => handleTimeOutTooltip(setTooltip3)}/>
                     </Tooltip>
                   </div>

                 </div>
                 <div className="col-12 col-md-6 d-flex">
                   <div className="checkBox_yellow">
                     <FormControlLabel control={<Checkbox
                        id="trademark"
                        checked={selector?.multi_sender?.trademark}
                        onChange={e => {
                          dispatch(setTrademarkSender(e.target.checked))
                          handleTimeOutTooltip(setTooltip4)
                        }}/>}
                                       label={t("singleOrder.packageInfo.t12")}/>
                   </div>
                   <div className="helper">
                     <Tooltip title={
                       selector?.multi_sender?.trademark ?
                          t("singleOrder.packageInfo.t30")
                          :
                          t("singleOrder.packageInfo.t31")

                     } PopperProps={{
                       disablePortal: true,
                     }}
                              onClose={() => setTooltip4(false)}
                              open={tooltip4}
                              placement="top-start"
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener>
                       <InfoIcon color="primary" onClick={() => handleTimeOutTooltip(setTooltip4)}/>
                     </Tooltip>
                   </div>
                 </div>
                 <div className="col-12 col-md-6 d-flex">
                   <div className="checkBox_yellow">
                     <FormControlLabel
                        control={<Checkbox id="breakable" checked={selector?.multi_sender?.breakable}
                                           onChange={e => {
                                             dispatch(setBreakableSender(e.target.checked))
                                             handleTimeOutTooltip(setTooltip5)
                                           }}/>}
                        label={t("singleOrder.packageInfo.t22")}/>
                   </div>
                   <div className="helper">
                     <Tooltip title={t("singleOrder.packageInfo.t32")}
                              PopperProps={{disablePortal: true}}
                              onClose={() => setTooltip5(false)}
                              open={tooltip5}
                              placement="top-start"
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener>
                       <InfoIcon color="primary" onClick={() => handleTimeOutTooltip(setTooltip5)}/>
                     </Tooltip>
                   </div>
                 </div>
                 <div className="col-12 col-md-6 d-flex">
                   <div className="checkBox_yellow">
                     <FormControlLabel
                        control={<Checkbox id="liquid" checked={selector?.multi_sender?.liquid}
                                           onChange={e => {
                                             dispatch(setLiquidSender(e.target.checked))
                                             handleTimeOutTooltip(setTooltip6)
                                           }}/>}
                        label={t("singleOrder.packageInfo.t23")}/>
                   </div>
                   <div className="helper">
                     <Tooltip title={t("singleOrder.packageInfo.t33")}
                              PopperProps={{disablePortal: true}}
                              onClose={() => setTooltip6(false)}
                              open={tooltip6}
                              placement="top-start"
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener>
                       <InfoIcon color="primary" onClick={() => handleTimeOutTooltip(setTooltip6)}/>
                     </Tooltip>
                   </div>
                 </div>
               </div>
             </section>

           </div>
           {selector?.multi_info_box?.excelList?.length > 0 &&
           <div className="col-12">
             <section className="excel">
               <table className="table">
                 <thead>
                 <tr>
                   <th scope="col">{t("multiOrder.s1.t22")}</th>
                   {selector?.multi_info_box?.excelList?.map((item, index) => {
                     return index === 0 && Object.keys(item).map(i => <th scope="col">{i}</th>)
                   })
                   }
                 </tr>
                 </thead>
                 <tbody>
                 {selector?.multi_info_box?.excelList?.map((item1, index1) => (
                    <tr key={index1}>
                      <td>{index1}</td>
                      {Object.values(item1).map((item2, index2) => <td>{item2}</td>)}
                    </tr>
                 ))}
                 </tbody>
               </table>
             </section>
           </div>
           }
         </div>


         <Dialog
            open={beforeAddressDialog}
            onClose={() => setBeforeAddressDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="addressDialog"
         >
           <DialogTitle id="alert-dialog-title">
             <div className="icon ">

               {/*<img src="/static/img/icons/location.svg" alt="location"/>*/}
             </div>
           </DialogTitle>
           <DialogContent>
             <div className="closed">
               <button type="button" onClick={() => setBeforeAddressDialog(false)} id="closeBeforeAddressDialog">
                 <CancelIcon/>
               </button>
             </div>
             <h5>{t("multiOrder.s1.t2")}</h5>
             <Autocomplete
                inputValue={selector?.multi_sender?.address}
                noOptionsText={t("autoComplete.t1")}
                value={selector?.multi_sender?.address}
                id="previous-address-sender-1"
                disablePortal
                onChange={(e, value, reason) => {
                  if (reason === 'clear') {
                    setInfoSender(null)
                  } else {
                    setInfoSender(value)
                  }
                }}
                options={listAddress || []}
                getOptionLabel={(option) => option?.Address1 || ''}
                renderOption={(props, option) => <li {...props}
                                                     key={option?.Id}>{option?.Address1}</li>}
                renderInput={(params) =>
                   <TextField {...params}
                              hiddenLabel
                              size="small"
                              placeholder={t("singleOrder.sender.t16")}
                              onChange={event => {
                                dispatch(setAddressSender(event.target.value))
                                event.target.value?.length >= 3 && getPreviousAddress(event.target.value)
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                   <React.Fragment>
                                     {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                     {params.InputProps.endAdornment}
                                   </React.Fragment>
                                ),
                              }}
                   />}
             />
           </DialogContent>
           <DialogActions>
             <Button className="yellow" onClick={() => setBeforeAddressDialog(false)} id="closeBeforeAddressDialog">
               {t("multiOrder.s1.t15")}
             </Button>
           </DialogActions>
         </Dialog>

         <Dialog
            open={afterAddressDialog}
            onClose={handleRemoveNewAddress}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="addressDialog"
         >
           <DialogTitle id="alert-dialog-title">
             <div className="icon ">
               <Plus/>
             </div>
           </DialogTitle>
           <DialogContent>
             <div className="closed">
               <button type="button" onClick={handleRemoveNewAddress} id="handleRemoveNewAddress">
                 <CancelIcon/>
               </button>
             </div>
             <h5>{t("multiOrder.s1.t3")}</h5>
             <Autocomplete
                inputValue={textStateAndCity}
                noOptionsText={t("autoComplete.t1")}
                id="previous-address-sender-3"
                disablePortal
                autoHighlight
                loading={selector?.loading?.isLoading}
                onChange={(e, value, reason) => {
                  if (reason === 'clear') {
                    setTextStateAndCity('')
                    setNewStateAndCity(null)
                    setInfoStateAndCity(null)
                  } else {
                    setTextStateAndCity(value?.name)
                    setNewStateAndCity(value)
                  }
                }}
                options={listStateAndCity || []}
                getOptionLabel={(option) => option?.name}
                renderInput={(params) =>
                   <TextField {...params}
                              hiddenLabel
                              size="small"
                              placeholder={t("singleOrder.sender.t28")}
                              onChange={(event) => {
                                setTextStateAndCity(event?.target?.value)
                                event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                   <React.Fragment>
                                     {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                     {params.InputProps.endAdornment}
                                   </React.Fragment>
                                ),
                              }}
                   />}
             />

             {
               validationShow?.stateAndCity &&
               <p className="error">{validationShow?.stateAndCity}</p>
             }

             {
               newStateAndCity && <>
             <textarea rows="2" value={newAddress} placeholder={t("multiOrder.s1.t20")}
                       onChange={e => setNewAddress(e.target.value)} id="newAddress"/>

                 {
                   validationShow?.newAddress &&
                   <p className="error">{validationShow?.newAddress}</p>
                 }

                 <SimpleMap
                    handlerLngFromMap={(event) => dispatch(setLngSender(event))}
                    handlerLatFromMap={(event) => dispatch(setLatSender(event))}
                    handlerAddressFromMap={(event) => setNewAddress(event?.subdivision_prefix + " " + event?.address)}
                    lngToMap={selector?.multi_sender?.lng}
                    latToMap={selector?.multi_sender?.lat}
                    coordinates={[
                      {
                        "pointX": selector?.multi_sender?.lat,
                        "pointY": selector?.multi_sender?.lng
                      }
                    ]}
                    searchInMap={textStateAndCity}
                    showSearchInMap={false}
                 />
               </>
             }
           </DialogContent>
           <DialogActions>
             <Button className="yellow" onClick={validationsNewAddress} id="validationsNewAddress">
               {t("multiOrder.s1.t21")}
             </Button>
           </DialogActions>
         </Dialog>

         {/*set coordinate dialog*/}
         <Dialog
            open={coordinateDialog}
            onClose={() => setCoordinateDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="addressDialog"
         >
           <DialogTitle id="alert-dialog-title">
             <div className="icon ">
               <Plus/>
             </div>
           </DialogTitle>
           <DialogContent>
             <div className="closed">
               <button type="button" onClick={() => setCoordinateDialog(false)} id="closeCoordinateDialog">
                 <CancelIcon/>
               </button>
             </div>
             <h5>{t("singleOrder.receiver.t29")}</h5>
             <SimpleMap
                handlerLngFromMap={(event) => dispatch(setLngSender(event))}
                handlerLatFromMap={(event) => dispatch(setLatSender(event))}
                coordinates={[
                  {
                    "pointX": selector?.multi_sender?.lat,
                    "pointY": selector?.multi_sender?.lng
                  }
                ]}
             />
           </DialogContent>
           <DialogActions>
             <Button className="yellow" onClick={() => {
               setCoordinateDialog(false)
             }} id="closeCoordinateDialog">
               {t("singleOrder.receiver.t22")}
             </Button>
           </DialogActions>
         </Dialog>
       </div>
     </>
  )
}
